import { projects } from './projects';
import { roundedTotalUsers } from './reach';

export type SiteStatId = 'users' | 'languages' | 'storeApps' | 'websites';

export interface SiteStat {
    id: SiteStatId;
    value: number;
    suffix?: string;
}

export const siteStats: SiteStat[] = [
    { id: 'users', value: roundedTotalUsers(), suffix: '+' },
    { id: 'languages', value: Math.max(...projects.map((project) => project.localeCount)) },
    { id: 'storeApps', value: projects.filter((project) => project.links.some((link) => link.kind !== 'website')).length },
    { id: 'websites', value: projects.filter((project) => project.links.some((link) => link.kind === 'website')).length }
];

export function siteStat(id: SiteStatId): SiteStat {
    const stat = siteStats.find((candidate) => candidate.id === id);
    if (!stat) throw new Error(`Unknown site stat "${id}"`);
    return stat;
}
